import { compose } from 'recompose';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as i18nSelectors } from 'mage-i18n';
import { thunks as stateThunks } from 'mage-state';
import { Column, Row, withResponsive } from 'mage-components';
import { UserMenu } from '@merchant-portal/core';
import { components as coreComponents } from 'mage-core';
import { LanguageSelector } from 'moet-core';
import { isKustomPartner } from '@/selectors/data';
/* eslint-disable no-restricted-imports */
import KlarnaLogoFull from '../../static/KlarnaLogoFull.svg';
import KustomLogoSVG from '../../static/kustom.svg';
/* eslint-disable no-restricted-imports */

import { isPreAssessmentMerchant } from '@/selectors/merchant';
const styles = {
  zIndex: 4,
  padding: '17px 0',
  backgroundColor: 'rgb(23, 23, 23)',
  position: 'sticky',
  top: 0,
};

const SplitImageTopBar = ({
  isPreAssessmentMerchant,
  language,
  saveLanguage,
  userId,
  logout,
  isKustomPartner,
}) => {
  return (
    <Row spacing={{ mobile: 0 }} alignItems="center" extraStyles={styles}>
      <Column columns={{ mobile: 6 }}>
        <Row spacing={{ mobile: 0 }} justify="center">
          <Column columns={{ mobile: 10, tablet: 11 }}>
            {isKustomPartner ? (
              <img
                src={KustomLogoSVG}
                alt="Kustom Logo"
                style={{ width: '120px', maxWidth: '100%', marginTop: '8px' }}
              />
            ) : (
              <img
                src={KlarnaLogoFull}
                alt="Klarna Logo"
                style={{ width: '120px', maxWidth: '100%' }}
              />
            )}
          </Column>
        </Row>
      </Column>
      <Column columns={{ mobile: 6 }}>
        <Row spacing={{ mobile: 0 }} justify="center">
          {!isPreAssessmentMerchant && (
            <Column columns={{ mobile: 10, tablet: 11 }} alignItems="flex-end">
              {userId ? (
                <UserMenu key="user-button" onLogoutClick={logout} />
              ) : (
                <LanguageSelector
                  language={language}
                  saveLanguage={language => saveLanguage(userId, language)}
                />
              )}
            </Column>
          )}
        </Row>
      </Column>
    </Row>
  );
};

SplitImageTopBar.propTypes = {
  isPreAssessmentMerchant: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  saveLanguage: PropTypes.func.isRequired,
  isKustomPartner: PropTypes.bool,
  userId: PropTypes.string,
};

export default compose(
  coreComponents.withTokenHelper(tokenHelper => ({
    userId: tokenHelper.getUserId(),
  })),
  connect(
    state => ({
      isPreAssessmentMerchant: isPreAssessmentMerchant(state),
      language: i18nSelectors.language(state),
      isKustomPartner: isKustomPartner(state),
    }),
    {
      saveLanguage: stateThunks.saveLanguage,
      logout: stateThunks.logout,
    },
  ),
)(withResponsive(SplitImageTopBar));
